import { logInDev } from 'IMPUtils/index'

export function capsLockCheck(event: JQuery.KeyPressEvent) {
    logInDev("capsLockCheck");
    const kc = event.key ? parseInt(event.key) : event.which
    const sk = event.shiftKey ? event.shiftKey : kc === 16
    if (((kc >= 65 && kc <= 90) && !sk) || ((kc >= 97 && kc <= 122) && sk)) {
        $('#divCapsLockWarning').css({ visibility: 'visible' })
        $('#divCapsLockWarning').css({ display: "block" })
    } else {
        $('#divCapsLockWarning').css({ visibility: 'hidden' })
        $('#divCapsLockWarning').css({ display: "none" })
    }
}